// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardSlot_gamecard_window__vINDR {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
}

.CardSlot_skeleton__PB\\+qa {
    height: 200px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: green;*/
    /*background-image: -webkit-linear-gradient(left, #ececec 0px, #f4f4f4 40px, #ececec 80px);*/
    /*background-image: -o-linear-gradient(left, #ececec 0px, #f4f4f4 40px, #ececec 80px);;*/
    /*background-image: linear-gradient(90deg, #ececec 0px, #f4f4f4 40px, #ececec 80px);*/
    /*background-size: 250px;*/
    /*-webkit-animation: shine-loading-image 2s infinite ease-out;*/
    /*animation: shine-loading-image 2s infinite ease-out;*/
}


@keyframes CardSlot_shine-loading-image__vuXcm {
    0% {
        background-position: -32px;
    }

    40%,
    100% {
        background-position: 208px;
    }
}

.CardSlot_active_card__K01Y9 {
    opacity: 1 !important;
}

.CardSlot_preloadimg__oK6OH {
    height: 40px !important;
}

.CardSlot_gamecard_window__vINDR img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.CardSlot_gamecard__4mE59 {
    position: relative;
    opacity: 1;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 5px 10px 0 #000;
    border: 2px solid transparent;
    background: #0f1127;
    transition: transform 0.8s ease, box-shadow 0.3s ease, opacity 0.8s ease, border-color 0.3s ease, border-width 0.3s ease;


}

.CardSlot_gamecard__4mE59::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom right, rgba(255, 255, 255, 0.2), rgba(0, 0, 0, 0.2));
    mix-blend-mode: overlay;
    pointer-events: none;
    z-index: 1;
}

.CardSlot_containerLike__Yt2Kl {
    position: absolute;
    right: 0;
    top: 0;
    padding: 10px;
    font-size: 40px;
    color: #ec2929;
}

.CardSlot_gamecard__4mE59:hover {
    border-color: #11bebc;
    border-width:2px;
    z-index: 4;


}

.CardSlot_gamecard_links__GE2J3 a {
    width: 150px;

}

.CardSlot_buttonConnect__P-7CS {
    text-decoration: none;
    opacity: 1 !important;
    position: relative;
    background: #1fd73e;
    color: black;
    text-decoration: none;
    text-align: center;
    border-radius: 10px;
    border: none;
    letter-spacing: 0.1rem;
    font-size: 1rem;
    padding: 0.5rem;
    font-family: Poppins, sans-serif;
    font-weight: 700;
    transition: 0.2s;
    margin-bottom: 17px;
}

.CardSlot_buttonConnect__P-7CS.CardSlot_demo__3AWs0 {
    background-color: #eaae2e;
}

.CardSlot_buttonLike__uLg0g {

    text-decoration: none;
    opacity: 1 !important;
    position: relative;
    background: #1fb2d7;
    color: black;
    text-decoration: none;
    border-radius: 10px;
    border: none;
    letter-spacing: 0.1rem;
    font-size: 15px;
    padding: 0.5rem;
    font-family: Poppins, sans-serif;
    font-weight: 500;
    transition: 0.2s;
    display: flex;
    gap: 0.3rem;
    justify-content: space-between;


}

.CardSlot_buttonLike__uLg0g i {
    color: red;
    font-size: 18px;
}

@keyframes CardSlot_fadeIn__6vWT- {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes CardSlot_fadeOut__EdcEl {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.CardSlot_gamecard_links__GE2J3 {
    position: absolute;
    opacity: 1;
    /* Начальное значение непрозрачности */
    transition: opacity 0.5s ease;
    /* Устанавливаем переход для свойства opacity */

    top: 0;
    left: 0;
    background-color: #000c;

    width: 100%;
    height: 100%;

    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;


}

.CardSlot_disable_button__Cw1eY {
    display: none !important;
}

.CardSlot_gamecard_links__GE2J3.CardSlot_state-disable__BEJ5C {
    display: none !important;
}

.CardSlot_gamecard_links__GE2J3 a {
    color: black;
    text-decoration: none;
}


.CardSlot_gamecard_title__P\\+EoK {
    display: flex;
    justify-content: center;
    flex: none;
    flex-direction: column;

    font-size: 18px;
    white-space: nowrap;

    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;


    overflow: hidden;
    margin-top: 5px;
    margin-bottom: 5px;


    overflow-wrap: break-word;
    padding: 5px;
    text-align: center;
    text-overflow: ellipsis;
}

.CardSlot_gamecard_name_provider__TOCdF {

    display: flex;
    justify-content: center;
    flex: none;
    flex-direction: column;

    font-size: 13px;
    font-weight: 500;
    color: #c6c6ec;
    margin-bottom: 10px;
    font-family: Poppins, sans-serif;


    overflow: hidden;


    overflow-wrap: break-word;
    padding: 5px;
    text-align: center;
    text-overflow: ellipsis;
}

.CardSlot_footer_card__6\\+Arw {
    display: flex;
    justify-content: space-between;
}

.CardSlot_footer_card_position_center__m8fv2 {
    justify-content: center;
}

.CardSlot_footer_card__6\\+Arw div {


    flex: none;
    flex-direction: column;

    font-size: 13px;
    font-weight: 500;
    color: #808099;
    font-family: Poppins, sans-serif;


    overflow: hidden;


    overflow-wrap: break-word;
    padding: 5px;
    text-align: center;
    text-overflow: ellipsis;
}

.CardSlot_gamecard_inf__xIcVh {


    display: flex;

    flex-direction: column;
}

@media only screen and (max-width: 1000px) {
    /*.gamecard_links button{*/
    /*    width: 100px;*/
    /*}*/

    .CardSlot_skeleton__PB\\+qa {
        height: 120px;
    }

    .CardSlot_preloadimg__oK6OH {
        height: 30px !important;
    }

    .CardSlot_gamecard_title__P\\+EoK {
        font-size: 13px;
    }

    .CardSlot_containerLikeButton__zXyyv {

        margin-top: 20px;
        font-size: 35px !important;
    }

    .CardSlot_buttonLike__uLg0g {
        font-size: 15px;
    }

    .CardSlot_gamecard_name_provider__TOCdF {
        margin-bottom: 0;

    }

    .CardSlot_gamecard_window__vINDR {
        height: 150px;
    }

    .CardSlot_gamecard_title__P\\+EoK {

        margin-bottom: 0;
    }

    .CardSlot_footer_card__6\\+Arw {
        flex-direction: column;
        justify-content: center;


    }

    .CardSlot_mainContainer__NyAmV {
        padding: 5px;
    }


}`, "",{"version":3,"sources":["webpack://./src/Pages/SlotsIgrator/components/UI/cardSlot/CardSlot.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,4FAA4F;IAC5F,wFAAwF;IACxF,qFAAqF;IACrF,0BAA0B;IAC1B,+DAA+D;IAC/D,uDAAuD;AAC3D;;;AAcA;IACI;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;IAC7B,mBAAmB;IACnB,wHAAwH;;;AAG5H;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0FAA0F;IAC1F,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;;;AAGd;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,8BAA8B;;;AAGlC;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,sCAAsC;IACtC,6BAA6B;IAC7B,+CAA+C;;IAE/C,MAAM;IACN,OAAO;IACP,uBAAuB;;IAEvB,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;;;AAG1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,sBAAsB;;IAEtB,eAAe;IACf,mBAAmB;;IAEnB,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;;;IAGhC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;;IAGlB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,sBAAsB;;IAEtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gCAAgC;;;IAGhC,gBAAgB;;;IAGhB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;IAGI,UAAU;IACV,sBAAsB;;IAEtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;;;IAGhC,gBAAgB;;;IAGhB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;;IAGI,aAAa;;IAEb,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,IAAI;;IAEJ;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;;IAEpB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;;;IAG3B;;IAEA;QACI,YAAY;IAChB;;;AAGJ","sourcesContent":[".gamecard_window {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    position: relative;\n}\n\n.skeleton {\n    height: 200px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /*background-color: green;*/\n    /*background-image: -webkit-linear-gradient(left, #ececec 0px, #f4f4f4 40px, #ececec 80px);*/\n    /*background-image: -o-linear-gradient(left, #ececec 0px, #f4f4f4 40px, #ececec 80px);;*/\n    /*background-image: linear-gradient(90deg, #ececec 0px, #f4f4f4 40px, #ececec 80px);*/\n    /*background-size: 250px;*/\n    /*-webkit-animation: shine-loading-image 2s infinite ease-out;*/\n    /*animation: shine-loading-image 2s infinite ease-out;*/\n}\n\n@-webkit-keyframes shine-loading-image {\n    0% {\n        background-position: -32px;\n    }\n\n    40%,\n    100% {\n        background-position: 208px;\n    }\n}\n\n\n@keyframes shine-loading-image {\n    0% {\n        background-position: -32px;\n    }\n\n    40%,\n    100% {\n        background-position: 208px;\n    }\n}\n\n.active_card {\n    opacity: 1 !important;\n}\n\n.preloadimg {\n    height: 40px !important;\n}\n\n.gamecard_window img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.gamecard {\n    position: relative;\n    opacity: 1;\n    display: flex;\n    flex-direction: column;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 5px 10px 0 #000;\n    border: 2px solid transparent;\n    background: #0f1127;\n    transition: transform 0.8s ease, box-shadow 0.3s ease, opacity 0.8s ease, border-color 0.3s ease, border-width 0.3s ease;\n\n\n}\n\n.gamecard::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to bottom right, rgba(255, 255, 255, 0.2), rgba(0, 0, 0, 0.2));\n    mix-blend-mode: overlay;\n    pointer-events: none;\n    z-index: 1;\n}\n\n.containerLike {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: 10px;\n    font-size: 40px;\n    color: #ec2929;\n}\n\n.gamecard:hover {\n    border-color: #11bebc;\n    border-width:2px;\n    z-index: 4;\n\n\n}\n\n.gamecard_links a {\n    width: 150px;\n\n}\n\n.buttonConnect {\n    text-decoration: none;\n    opacity: 1 !important;\n    position: relative;\n    background: #1fd73e;\n    color: black;\n    text-decoration: none;\n    text-align: center;\n    border-radius: 10px;\n    border: none;\n    letter-spacing: 0.1rem;\n    font-size: 1rem;\n    padding: 0.5rem;\n    font-family: Poppins, sans-serif;\n    font-weight: 700;\n    transition: 0.2s;\n    margin-bottom: 17px;\n}\n\n.buttonConnect.demo {\n    background-color: #eaae2e;\n}\n\n.buttonLike {\n\n    text-decoration: none;\n    opacity: 1 !important;\n    position: relative;\n    background: #1fb2d7;\n    color: black;\n    text-decoration: none;\n    border-radius: 10px;\n    border: none;\n    letter-spacing: 0.1rem;\n    font-size: 15px;\n    padding: 0.5rem;\n    font-family: Poppins, sans-serif;\n    font-weight: 500;\n    transition: 0.2s;\n    display: flex;\n    gap: 0.3rem;\n    justify-content: space-between;\n\n\n}\n\n.buttonLike i {\n    color: red;\n    font-size: 18px;\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n.gamecard_links {\n    position: absolute;\n    opacity: 1;\n    /* Начальное значение непрозрачности */\n    transition: opacity 0.5s ease;\n    /* Устанавливаем переход для свойства opacity */\n\n    top: 0;\n    left: 0;\n    background-color: #000c;\n\n    width: 100%;\n    height: 100%;\n\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\n\n}\n\n.disable_button {\n    display: none !important;\n}\n\n.gamecard_links.state-disable {\n    display: none !important;\n}\n\n.gamecard_links a {\n    color: black;\n    text-decoration: none;\n}\n\n\n.gamecard_title {\n    display: flex;\n    justify-content: center;\n    flex: none;\n    flex-direction: column;\n\n    font-size: 18px;\n    white-space: nowrap;\n\n    font-weight: 500;\n    color: white;\n    font-family: Poppins, sans-serif;\n\n\n    overflow: hidden;\n    margin-top: 5px;\n    margin-bottom: 5px;\n\n\n    overflow-wrap: break-word;\n    padding: 5px;\n    text-align: center;\n    text-overflow: ellipsis;\n}\n\n.gamecard_name_provider {\n\n    display: flex;\n    justify-content: center;\n    flex: none;\n    flex-direction: column;\n\n    font-size: 13px;\n    font-weight: 500;\n    color: #c6c6ec;\n    margin-bottom: 10px;\n    font-family: Poppins, sans-serif;\n\n\n    overflow: hidden;\n\n\n    overflow-wrap: break-word;\n    padding: 5px;\n    text-align: center;\n    text-overflow: ellipsis;\n}\n\n.footer_card {\n    display: flex;\n    justify-content: space-between;\n}\n\n.footer_card_position_center {\n    justify-content: center;\n}\n\n.footer_card div {\n\n\n    flex: none;\n    flex-direction: column;\n\n    font-size: 13px;\n    font-weight: 500;\n    color: #808099;\n    font-family: Poppins, sans-serif;\n\n\n    overflow: hidden;\n\n\n    overflow-wrap: break-word;\n    padding: 5px;\n    text-align: center;\n    text-overflow: ellipsis;\n}\n\n.gamecard_inf {\n\n\n    display: flex;\n\n    flex-direction: column;\n}\n\n@media only screen and (max-width: 1000px) {\n    /*.gamecard_links button{*/\n    /*    width: 100px;*/\n    /*}*/\n\n    .skeleton {\n        height: 120px;\n    }\n\n    .preloadimg {\n        height: 30px !important;\n    }\n\n    .gamecard_title {\n        font-size: 13px;\n    }\n\n    .containerLikeButton {\n\n        margin-top: 20px;\n        font-size: 35px !important;\n    }\n\n    .buttonLike {\n        font-size: 15px;\n    }\n\n    .gamecard_name_provider {\n        margin-bottom: 0;\n\n    }\n\n    .gamecard_window {\n        height: 150px;\n    }\n\n    .gamecard_title {\n\n        margin-bottom: 0;\n    }\n\n    .footer_card {\n        flex-direction: column;\n        justify-content: center;\n\n\n    }\n\n    .mainContainer {\n        padding: 5px;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gamecard_window": `CardSlot_gamecard_window__vINDR`,
	"skeleton": `CardSlot_skeleton__PB+qa`,
	"active_card": `CardSlot_active_card__K01Y9`,
	"preloadimg": `CardSlot_preloadimg__oK6OH`,
	"gamecard": `CardSlot_gamecard__4mE59`,
	"containerLike": `CardSlot_containerLike__Yt2Kl`,
	"gamecard_links": `CardSlot_gamecard_links__GE2J3`,
	"buttonConnect": `CardSlot_buttonConnect__P-7CS`,
	"demo": `CardSlot_demo__3AWs0`,
	"buttonLike": `CardSlot_buttonLike__uLg0g`,
	"disable_button": `CardSlot_disable_button__Cw1eY`,
	"state-disable": `CardSlot_state-disable__BEJ5C`,
	"gamecard_title": `CardSlot_gamecard_title__P+EoK`,
	"gamecard_name_provider": `CardSlot_gamecard_name_provider__TOCdF`,
	"footer_card": `CardSlot_footer_card__6+Arw`,
	"footer_card_position_center": `CardSlot_footer_card_position_center__m8fv2`,
	"gamecard_inf": `CardSlot_gamecard_inf__xIcVh`,
	"containerLikeButton": `CardSlot_containerLikeButton__zXyyv`,
	"mainContainer": `CardSlot_mainContainer__NyAmV`,
	"shine-loading-image": `CardSlot_shine-loading-image__vuXcm`,
	"fadeIn": `CardSlot_fadeIn__6vWT-`,
	"fadeOut": `CardSlot_fadeOut__EdcEl`
};
export default ___CSS_LOADER_EXPORT___;
